import {Link, RiverAccordion, Text} from '@primer/react-brand'
import {Image, VideoPlayer} from '@primer/react-brand-next'

import {getImageSources} from '@github-ui/swp-core/lib/utils/images'

import {renderWithNoMarks} from '../utils'
import type {IconAssetLinkItem} from '../../../lib/types/contentful/contentTypes/iconAssetLinkItem'

export type FlexSuiteRiverAccordionProps = {
  items?: IconAssetLinkItem[]
}

export const FlexSuiteRiverAccordion = ({items}: FlexSuiteRiverAccordionProps) => {
  if (!items || items.length === 0) return null

  return (
    <>
      <RiverAccordion>
        {items.map(item => {
          const {heading, description, href, label, assetType, optionImage, optionVideo, optionPoster} = item.fields

          return (
            <RiverAccordion.Item key={item.sys.id}>
              <RiverAccordion.Heading as="h3">{renderWithNoMarks(heading)}</RiverAccordion.Heading>
              <RiverAccordion.Content>
                <Text>{renderWithNoMarks(description)}</Text>
                {href && label ? <Link href={href}>{label}</Link> : null}
              </RiverAccordion.Content>
              <RiverAccordion.Visual>
                {assetType === 'Video' && optionVideo ? (
                  <VideoPlayer title={optionVideo.fields.description ?? 'Video'} poster={optionPoster?.fields.file.url}>
                    <VideoPlayer.Source src={optionVideo.fields.file.url} type="video/mp4" />
                  </VideoPlayer>
                ) : optionImage ? (
                  <Image
                    as="picture"
                    src={`${optionImage.fields.file.url}?fm=webp`}
                    sources={getImageSources(optionImage.fields.file.url, {maxWidth: 720})}
                    alt={optionImage.fields.description ?? ''}
                  />
                ) : null}
              </RiverAccordion.Visual>
            </RiverAccordion.Item>
          )
        })}
      </RiverAccordion>
    </>
  )
}
